import { ActionType, TaxSelectedType } from 'Types/common';
import * as types from './types';

export const setTaxSelectedAction = (
  taxSelected: TaxSelectedType
): ActionType<{ taxSelected: TaxSelectedType }> => ({
  type: types.SET_TAX_SELECTED,
  payload: { taxSelected },
});
